export default [
  {
    title: 'Statistics',
    route: 'estadistica',
    icon: 'HomeIcon',
  },
  {
    header: 'Mi Liga',
  },
  {
    title: 'Calification',
    route: 'inscriptions',
    icon: 'AirplayIcon',
    action: 'read',
    resource: 'ACL',
    disabled: false,
  },
  {
    title: 'Technique',
    route: 'tecnica',
    icon: 'ClipboardIcon',
    disabled: false,
  },
  {
    title: ' Generador horarios',
    route: 'horarios',
    icon: 'ClipboardIcon',
    disabled: false,
  },
  {
    title: 'Sanctions',
    route: 'sanciones',
    icon: 'FrownIcon',
    disabled: false,
  },

  {
    title: 'Treasury',
    route: 'tesoreria',
    icon: 'KeyIcon',
  },
  {
    title: 'Mi Perfil',
    route: 'profile',
    icon: 'UserIcon',
  },
  {
    title: 'Auditoria',
    route: 'logs',
    icon: 'AlertTriangleIcon',
  },
  {
    title: 'Centro de Ayuda',
    route: 'ayuda',
    icon: 'HelpCircleIcon',
  },

  // {
  //   title: 'Samantha',
  //   route: 'samantha',
  //   icon: 'ClipboardIcon',
  // },
]
